import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTAddressToSDKAddress } from '@wix/sdk-runtime/transformations/address';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { createShippoConfiguration as universalCreateShippoConfiguration, deleteShippoConfiguration as universalDeleteShippoConfiguration, getShippoConfiguration as universalGetShippoConfiguration, queryShippoConfigurations as universalQueryShippoConfigurations, updateExtendedFields as universalUpdateExtendedFields, updateShippoConfiguration as universalUpdateShippoConfiguration, } from './ecom-v1-shippo-configuration-shippo-configurations.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function createShippoConfiguration(httpClient) {
    return (shippoConfiguration, options) => universalCreateShippoConfiguration(shippoConfiguration, options, 
    // @ts-ignore
    { httpClient });
}
export function getShippoConfiguration(httpClient) {
    return (shippoConfigurationId) => universalGetShippoConfiguration(shippoConfigurationId, 
    // @ts-ignore
    { httpClient });
}
export function updateShippoConfiguration(httpClient) {
    return (_id, shippoConfiguration) => universalUpdateShippoConfiguration(_id, shippoConfiguration, 
    // @ts-ignore
    { httpClient });
}
export function deleteShippoConfiguration(httpClient) {
    return (shippoConfigurationId) => universalDeleteShippoConfiguration(shippoConfigurationId, 
    // @ts-ignore
    { httpClient });
}
export function queryShippoConfigurations(httpClient) {
    return () => universalQueryShippoConfigurations(
    // @ts-ignore
    { httpClient });
}
export function updateExtendedFields(httpClient) {
    return (_id, namespace, options) => universalUpdateExtendedFields(_id, namespace, options, 
    // @ts-ignore
    { httpClient });
}
export const onShippoConfigurationCreated = EventDefinition('wix.ecom.v1.shippo_configuration_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTAddressToSDKAddress,
        paths: [{ path: 'entity.shipFromAddress' }],
    },
])))();
export const onShippoConfigurationDeleted = EventDefinition('wix.ecom.v1.shippo_configuration_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTAddressToSDKAddress,
        paths: [{ path: 'entity.shipFromAddress' }],
    },
])))();
export const onShippoConfigurationUpdated = EventDefinition('wix.ecom.v1.shippo_configuration_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTAddressToSDKAddress,
        paths: [{ path: 'entity.shipFromAddress' }],
    },
])))();
export { CalculationType, DomesticService, InternationalService, PackageType, SortOrder, WebhookIdentityType, } from './ecom-v1-shippo-configuration-shippo-configurations.universal.js';
//# sourceMappingURL=ecom-v1-shippo-configuration-shippo-configurations.public.js.map